import { IInventoryPage } from '../../../inventory-page.interface';


export const RESEARCH_AI_AI_DESIGN_EDITOR_PAGE: IInventoryPage = {
	'route': '/research/ai/ai-design-editor',
	'title': 'AI Design Editor',
	'uiReference': [
		'Close',
		'Design Amount',
		'Version Update',
		'Replace',
		'Copy',
		'Clear',
		'Prompt |',
		'Generate |',
		'Replace Text',
		'&times;',
		'Designs: Create more in s... Analyzing Your design....',
		'Undo Changes',
		'Remove',
		'Click to Upload',
		'or drag and drop',
		'Upscale |',
		'Designs Preview',
		'Download Designs',
		'Custom Upscale Variant',
		'Width (px)',
		'Please enter a valid width between 1 and 6000 pixels.',
		'Height (px)',
		'Please enter a valid height between 1 and 6000 pixels.',
		'Apply'
	],
	'sources': [
		'apps/flying-projects/frontend/webapp/src/app/pages/shared/ai-design-editor/ai-design-editor.module.ts',
		'apps/flying-projects/frontend/webapp/src/app/pages/shared/ai-design-editor/ai-design-editor.component.ts',
		'apps/flying-projects/frontend/webapp/src/app/pages/shared/ai-design-editor/ai-design-editor.component.html',
		'domains/ai-image-editor/frontend/src/components/image-editor/image-editor.component.ts',
		'domains/ai-image-editor/frontend/src/components/image-editor/image-editor.component.html',
		'domains/ai-image-editor/frontend/src/components/image-editor/image-editor-dashboard/image-editor-dashboard.component.ts',
		'domains/ai-image-editor/frontend/src/components/image-editor/image-editor-dashboard/image-editor-dashboard.component.html',
		'domains/ai-image-editor/frontend/src/components/image-editor/image-editor-action/image-editor-action.component.ts',
		'domains/ai-image-editor/frontend/src/components/image-editor/image-editor-action/image-editor-action.component.html',
		'domains/ai-image-editor/frontend/src/components/image-editor/image-editor-action/image-editor-card/image-editor-card.component.ts',
		'domains/ai-image-editor/frontend/src/components/image-editor/image-editor-action/image-editor-card/image-editor-card.component.html',
		'domains/ai-image-editor/frontend/src/components/image-editor/image-editor-preview/image-editor-preview.component.ts',
		'domains/ai-image-editor/frontend/src/components/image-editor/image-editor-preview/image-editor-preview.component.html'
	],
	'aliases': []
};
